<script>
import form from '@/utils/form';
import AvatarEditable from '@/components/AvatarEditable.vue';
import BasePopup from '@/components/BasePopup.vue';
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'MaterialCategoryForm',
  components: { BaseField, BasePopup, AvatarEditable },
  controller: null,
  data() {
    return {
      isOpened: false,
      avatar: null,
      form: {
        name: form.createFieldObject('string', 'Название материала', ''),
        sort: form.createFieldObject('int', 'Сортировка', ''),
        color: form.createFieldObject('string', 'Цвет', ''),
      },
    };
  },
  methods: {
    open(item) {
      this.isOpened = true;

      form.setValues(this.form, item);
      this.avatar = item.avatar;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      form.clear(this.form);
      this.$options.controller.resolve(result);
    },
    save() {
      const data = form.getValues(this.form);
      data.avatar = this.avatar?.['@id'] ?? null;
      this.close(data);
    },
  },
};
</script>

<template lang="pug">
BasePopup(@close="close(null)" v-if="isOpened")
  .material-category-form
    AvatarEditable(:avatar="avatar" @change="avatar = $event")
    BaseField._item(
      v-for="(field, name) in form"
      v-model="field.value"
      v-bind="field"
      :key="name"
      labelOuter
    )
    .buttons
      Btn(green @click="save") Сохранить
      Btn(grey @click="close(null)") Отмена

</template>

<style scoped lang="scss">
.material-category-form {
  display: grid;
  gap: 30px;
}
</style>
